import ActiveGradientButton from '../../svg/active-gradient-button';
import GradientButton from '../../svg/gradient-button';
import { Grid2 as Grid } from '@mui/material';
import React from 'react';
import { text } from 'node:stream/consumers';

// Define the types for the props
interface TimelineButtonsProps {
  page: string;
  timeline: string;
  handleTimelineChange: (newTimeline: string) => void;
  items: string[];
}

const getText = (item: string, page: string) => {
  let type = '';

  switch (item) {
    case 'all_time':
      type = 'ALL TIME';
      break;
    case 'current_month':
      type = 'MONTHLY';
      break;
    case 'current_week':
      type = 'WEEKLY';
      break;
    default:
      type = '';
      break;
  }

  return type;
};

const check = (item: string, timeline: string) => {
  return item.toUpperCase();
};

const TimelineButtons: React.FC<TimelineButtonsProps> = ({ page, timeline, handleTimelineChange, items }) => {
  return (
    <Grid container spacing={{ xs: 1, md: 3 }}>
      {items?.map((item, index) => (
        <Grid key={index}>
          {timeline === item ? (
            <ActiveGradientButton
              key={index}
              text={page === 'champs' ? getText(item, page) || '' : check(item, timeline)}
              onClick={() => handleTimelineChange(item)}
            />
          ) : (
            <GradientButton
              key={index}
              text={page === 'champs' ? getText(item, page) || '' : check(item, timeline)}
              onClick={() => handleTimelineChange(item)}
            />
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default TimelineButtons;
